import React from 'react';
import {isWeb} from '../constants';
import PushNotification from 'src/imports/pushnotification';
import {getModal} from '../actions/modal';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {getUser} from '../actions/user';
import {getNotification} from '../actions/notice';

const usePushNotif = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  {
    !isWeb
      ? PushNotification.configure({
          onNotification: function (notification) {
            switch (notification.data.title) {
              case 'Trip penalty': {
                const data = {
                  modal: false,
                  image: 'tripbillfine',
                  width: 90,
                  height: 65,
                  text: t('non_payment_general_alert'),
                  Notification: false,
                  btntext: t('view_trip'),
                  func: 'penalty',
                  cancletext: t('i_realized'),
                  number: t('cost_trip_deducted'),
                };
                dispatch(getModal(data));
                dispatch(getUser({notificationmodal: true}));
                return dispatch(
                  getNotification({title: notification.data.title}),
                );
              }
              case 'Trip paid': {
                const data = {
                  modal: false,
                  image: 'tripbillfine',
                  width: 90,
                  height: 65,
                  text: t('non_payment_general_alert'),
                  Notification: false,
                  btntext: t('view_trip'),
                  func: 'penalty',
                  cancletext: t('i_realized'),
                  number: t('cost_trip_deducted'),
                };
                dispatch(getModal(data));
                dispatch(getUser({notificationmodal: true}));
                return dispatch(
                  getNotification({title: notification.data.title}),
                );
              }
              case 'profile verified': {
                const data = {
                  modal: false,
                  image: 'noidcart',
                  width: 88,
                  height: 70,
                  text: '',
                  Notification: true,
                  func: 'idcart',
                  number: t('national_card_verified'),
                };
                dispatch(getModal(data));
                dispatch(
                  getUser({
                    notificationmodal: true,
                    active: true,
                    userStatus: 'active',
                  }),
                );
                return dispatch(
                  getNotification({title: notification.data.title}),
                );
              }
              case 'profile rejected': {
                // const data = {
                //   modal: false,
                //   image: 'noidcart',
                //   width: 88,
                //   height: 70,
                //   text: t('need_upload_national_card'),
                //   Notification: true,
                //   btntext: t('upload_image'),
                //   func: 'noidcart',
                //   number: t('national_card_fail'),
                // };
                dispatch(getModal(data));
                dispatch(
                  getUser({
                    notificationmodal: true,
                    userStatus: 'profile_rejected',
                  }),
                );
                return dispatch(
                  getNotification({title: notification.data.title}),
                );
              }
              case 'penalty': {
                const data = {
                  modal: true,
                  image: 'penaltycart',
                  width: 88,
                  height: 60,
                  text: notification.data.description,
                  Notification: true,
                  number: t('penalty_alert'),
                };
                dispatch(getModal(data));
                return dispatch(getUser({notificationmodal: true}));
              }
              case 'prize': {
                profileMutation.mutate();
                const data = {
                  modal: true,
                  image: 'confrimcharge',
                  width: 88,
                  height: 60,
                  text: notification.data.description,
                  Notification: true,
                  number: t('account_balance_charge_success'),
                };
                dispatch(getModal(data));
                return dispatch(getUser({notificationmodal: true}));
              }
              case 'trip ended': {
                const data = {
                  modal: true,
                  image: 'endTripIcon',
                  width: 88,
                  height: 60,
                  text: notification.data.description,
                  Notification: true,
                  func: 'tripended',
                  number: t('admin_end_trip'),
                };
                dispatch(getModal(data));
                dispatch(getVehicleslist({type: 'both'}));
                return dispatch(getUser({notificationmodal: true}));
              }
              default:
                return 0;
            }
          },
          popInitialNotification: true,
          requestPermissions: true,
        })
      : null;
  }

  return {};
};

export default usePushNotif;
